import { Link } from 'react-router-dom'
import { Button, TableContainer, TableHead, TableBody, TableRow, TableCell } from '@material-ui/core'

const UpcomingExamTables = ({examinations}) => {
  return (
    <TableContainer component="table">
      <TableHead>
        <TableRow>
          <TableCell>Name</TableCell>
          <TableCell>Section</TableCell>
          <TableCell>Start Date</TableCell>
          <TableCell>End Date</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {examinations?.length <= 0 && <>
          <TableRow>
            <TableCell colSpan={4} style={{textAlign: 'center', fontStyle: 'italic'}}>No Open Examinations</TableCell>
          </TableRow>
        </>}
        {examinations?.length > 0 && examinations.map((e) => (
          <TableRow>
            <TableCell>{e.examination.name}</TableCell>
            <TableCell>{e.classroom.name} - {e.classroom.section}</TableCell>
            <TableCell>
              {e.examination.start}
            </TableCell>
            <TableCell>
              {e.examination.end}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </TableContainer>
  )
}

export default UpcomingExamTables